<template>
  <div>

    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="fal fa-user" /></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        v-model="form.first_name"
        type="text"
        class="form-control"
        placeholder="First name"
        autocomplete="first_name"
        :state="vuelidate.first_name.$dirty ? !vuelidate.first_name.$invalid : null"
      />
      <b-form-invalid-feedback>
        Required
      </b-form-invalid-feedback>
    </b-input-group>

    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="fal fa-user" /></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        v-model="form.last_name"
        type="text"
        class="form-control"
        placeholder="Last name"
        autocomplete="last_name"
        :state="vuelidate.last_name.$dirty ? !vuelidate.last_name.$invalid : null"
      />
      <b-form-invalid-feedback>
        Required
      </b-form-invalid-feedback>
    </b-input-group>

    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text><i class="fal fa-phone" /></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input v-model="form.phone_number" type="text" class="form-control" placeholder="Phone number" autocomplete="phone_number" />
    </b-input-group>

    <b-input-group v-if="!no_email" class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text>@</b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        v-model="form.email"
        type="text"
        class="form-control"
        :disabled="disable_email"
        placeholder="Email"
        autocomplete="email"
        :state="vuelidate.email.$dirty ? !vuelidate.email.$invalid : null"
      />
      <b-form-invalid-feedback>
        Required
      </b-form-invalid-feedback>
    </b-input-group>

    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text>
          <i class="fal fa-id-badge"></i>
        </b-input-group-text>
      </b-input-group-prepend>
      <b-form-select
        v-model="form.role"
        type="text"
        class="form-control"
        autocomplete="role"
        :options="available_roles"
      >
        <template slot="first">
          <option :value="null" disabled>
            What's your role at the company?
          </option>
        </template>
      </b-form-select>
    </b-input-group>

  </div>
</template>

<script>
export default {
  name: 'CustomerContactFormGroup',
  props: {
    customer_contact: {
      type: Object,
      default: () => ({})
    },
    disable_email: {
      type: Boolean,
      default: false
    },
    vuelidate: {
      type: Object,
      default: () => ({})
    },
    no_email: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        first_name: null,
        last_name: null,
        phone_number: null,
        email: null,
        role: null
      },
      available_roles: ['Grower', 'Agronomist', 'Other']
    }
  },
  watch: {
    form: {
      handler: function () {
        this.$emit('onCustomerContactChange', this.form)
      },
      deep: true
    },
    customer_contact: {
      handler: function () {
        this.fillForm()
      },
      deep: true
    }
  },
  created () {
    this.fillForm()
  },
  methods: {
    fillForm () {
      if (this.customer_contact) {
        for (const i in this.form) { if (this.customer_contact[i]) { this.form[i] = this.customer_contact[i] } }
      }
    }
  }
}
</script>
